import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { UploadComponent } from '@app/shared/components/upload/upload.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
})
export class UploadFileComponent {
    @Input() buttonText = 'Import';
    @Input() disabled = false;
    @Input() accept = 'application/json';
    @Input() buttonSize = 'small';
    @Input() uploadLoading = false;
    @Input() needJudgeFileType = false;
    @Input() uploadElementId = 'upload';
    @Input() render?: TemplateRef<void>;

    @Output() selectFile = new EventEmitter();

    constructor(
        private message: NzMessageService
    ) {
    }

    beforeUpload = (file: NzUploadFile): boolean => {
        if (this.needJudgeFileType && !this.validFileType(file)) {
            return false;
        }
        this.selectFile.emit(file);
        return false;
    }

    uploadClick(): void {
        const upload = document.getElementById(this.uploadElementId);
        upload?.click();
    }

    validFileType(file: NzUploadFile | File): boolean {
        const fileName = file.name;
        if (this.accept.includes('image')) {
            const valid = /\.(tif|pjp|apng|xbm|jxl|sgvz|jpg|jpeg|ico|tiff|gif|svg|jfif|webg|png|pjpeg|avif)$/.test(fileName);
            if (!valid) {
                this.message.warning('The file must be an image');
            }
            return valid;
        } else if (this.accept.includes('xls')) {
            const valid = /\.(xls|xlsx|csv)$/.test(fileName);
            if (!valid) {
                this.message.warning('The file type must be excel');
            }
            return valid;
        }
        return true;
    }
}
